<main>

    <!-- Banner -->
    <div class="dv-banner breadcrumb__area breadcrumb__overlay breadcrumb__height p-relative fix"
         [style.background-image]="'url(' + bannerImage + ')'">
        <div class="container">
            <div class="row">
                <div class="col-xxl-12">
                    <div class="breadcrumb__content z-index text-center">
                        <h3 class="breadcrumb__title">Diwali Vouchers 2026</h3>
                        <div class="breadcrumb__list">
                            <span><a class="dv-no-underline" routerLink="/index">Home</a></span>
                            <span class="dvdr"><i class="fa fa-angle-right"></i></span>
                            <span>Diwali Vouchers</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="tp-feature-area pt-130 pb-110 p-relative z-index grey-bg-2 mt-4">
        <div class="container">

            <!-- Loading -->
            <div class="text-center py-5" *ngIf="loading">
                <div class="spinner-border text-danger" role="status"></div>
                <p class="mt-3 mb-0">Loading Diwali vouchers...</p>
            </div>

            <!-- Error -->
            <div class="alert alert-warning text-center dv-error" *ngIf="!loading && errorMsg">
                <p class="mb-2">{{ errorMsg }}</p>
                <button type="button" class="btn btn-outline-dark btn-sm me-2" *ngIf="mode === 'vouchers'"
                    (click)="backToCategories()">Back to Categories</button>
                <a class="btn btn-outline-dark btn-sm" routerLink="/index">Go to Home</a>
            </div>

            <!-- Success -->
            <div class="card dv-success text-center" *ngIf="!loading && orderRefnos.length">
                <div class="card-body">
                    <div class="dv-success-icon"><i class="fa fa-check"></i></div>
                    <h5>Your Diwali voucher order has been placed successfully!</h5>
                    <p class="dv-success-text">You will receive the GIFT CARD CODE through the WhatsApp BOT and
                        registered Email ID within 2 hours.</p>
                    <div class="dv-refs">
                        <span class="badge bg-success me-2 mb-2" *ngFor="let ref of orderRefnos">Ref: {{ ref }}</span>
                    </div>
                    <div class="mt-2">
                        <button type="button" class="btn dv-btn me-2" (click)="backToCategories()">Browse more
                            vouchers</button>
                        <a class="btn btn-outline-dark" routerLink="/index">Go to Home</a>
                    </div>
                </div>
            </div>

            <!-- ================= Category Grid ================= -->
            <ng-container *ngIf="!loading && !errorMsg && mode === 'categories'">
                <div class="text-center mb-4">
                    <h4 class="dv-section-title">Choose a voucher category</h4>
                    <p class="dv-section-sub">Select a brand to add vouchers to your Diwali cart.</p>
                </div>

                <div class="row row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 justify-content-center">
                    <div *ngFor="let cat of categories" class="col wow tpfadeUp">
                        <div class="tp-feature-item mb-30 text-center card-wrapper dv-category-card"
                            (click)="openCategory(cat)">
                            <div class="tp-feature-icon">
                                <img [src]="cat.images || 'assets/images/default.jpg'" [alt]="cat.name">
                            </div>
                            <div class="tp-feature-content">
                                <h4 class="tp-feature-title-sm">{{ cat.name }}</h4>
                                <span class="dv-count">{{ cat.product_count }} voucher(s)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- ================= Voucher List + Cart ================= -->
            <ng-container *ngIf="!loading && !errorMsg && mode === 'vouchers'">

                <!-- Budget bar -->
                <div class="card dv-budget mb-4">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-sm-4 text-sm-start text-center">
                                <span class="dv-budget-label">Your Diwali Budget</span>
                                <div class="dv-budget-amount">&#8377;{{ remainingAmount }}</div>
                            </div>
                            <div class="col-sm-4 text-sm-start text-center">
                                <span class="dv-budget-label">In Cart</span>
                                <div class="dv-budget-amount dv-budget-cart">&#8377;{{ cartTotal }}</div>
                            </div>
                            <div class="col-sm-4 text-sm-end text-center">
                                <span class="dv-budget-label">Remaining</span>
                                <div class="dv-budget-amount dv-budget-left">&#8377;{{ remainingAmount - cartTotal }}
                                </div>
                            </div>
                        </div>
                        <div class="dv-progress mt-3">
                            <div class="dv-progress-bar" [style.width.%]="budgetPercent"></div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                    <div>
                        <button type="button" class="btn btn-outline-secondary btn-sm me-2"
                            (click)="backToCategories()">&larr; All Categories</button>
                        <h5 class="dv-category-name d-inline">{{ categoryName }}</h5>
                    </div>
                    <span class="badge rounded-pill dv-cart-badge" *ngIf="cart.length">{{ cartQty }} in cart</span>
                </div>

                <!-- Voucher grid -->
                <div class="row row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 g-4">
                    <div *ngFor="let product of products" class="col">
                        <div class="card dv-voucher-card h-100">
                            <img [src]="productImage(product)" class="card-img-top dv-voucher-img"
                                [alt]="product.name">
                            <div class="card-body">
                                <h5 class="dv-voucher-name">{{ product.name }}</h5>
                                <p class="dv-voucher-desc">{{ product.product_details?.description }}</p>
                                <div class="dv-denoms">
                                    <button type="button" class="dv-denom"
                                        *ngFor="let denomination of product.selected_denominations"
                                        (click)="addToCart(product, denomination)">
                                        &#8377;{{ denomination }} <span class="dv-plus">+ Add</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Cart -->
                <div class="card dv-cart mt-4" *ngIf="cart.length">
                    <div class="card-body">
                        <h5 class="dv-cart-title"><i class="fa fa-shopping-cart"></i> Your Cart</h5>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item dv-cart-line" *ngFor="let line of cart">
                                <div class="d-flex align-items-center">
                                    <img [src]="line.image" class="dv-cart-thumb" alt="">
                                    <div class="ms-2">
                                        <div class="dv-cart-name">{{ line.name }}</div>
                                        <small class="dv-muted">&#8377;{{ line.denomination }} each</small>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="dv-qty">
                                        <button type="button" class="dv-qty-btn"
                                            (click)="changeQty(line, -1)">&minus;</button>
                                        <span class="dv-qty-value">{{ line.qty }}</span>
                                        <button type="button" class="dv-qty-btn" (click)="changeQty(line, 1)">+</button>
                                    </div>
                                    <strong class="dv-line-total">&#8377;{{ line.denomination * line.qty }}</strong>
                                    <button type="button" class="dv-remove" (click)="removeLine(line)"
                                        aria-label="Remove">&times;</button>
                                </div>
                            </li>
                        </ul>
                        <div
                            class="d-flex justify-content-between align-items-center mt-3 flex-wrap dv-cart-footer">
                            <div class="mb-2 mb-md-0">Total: <strong class="dv-total">&#8377;{{ cartTotal }}</strong>
                            </div>
                            <button type="button" class="btn dv-btn" (click)="placeOrder()"
                                [disabled]="validating || placing">
                                <span class="spinner-border spinner-border-sm me-2"
                                    *ngIf="validating || placing"></span>
                                {{ placing ? 'Placing Order...' : (validating ? 'Validating...' : 'Place Order') }}
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</main>
